import MenuTable from "../../components/Menu/MenuTable"
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useEffect } from "react";

function Menu() {
  const { authState } = useSelector(
    (state) => state
  );
  const { loggedIn } = authState;
  const navigate = useNavigate();

  useEffect(() => {
    if(loggedIn != true){
      navigate("/signin")
    }
  },[loggedIn]);
  
  return (
    <div className="">
      <MenuTable />
    </div>
  );
}

export default Menu;
